import VehicleSection from './VehicleSection';

export default VehicleSection;
